export default __webpack_public_path__ + "static/media/IMG3194.c77ce29e.jpg";